import React from 'react';
import { WithTranslation } from 'next-i18next';

import { withTranslation } from 'lib/i18n';

import phone from '../../images/Pictogram_phone.svg';
import watch from '../../images/Pictogram_watch.svg';

import SupportIconsWrap from './styled/SupportIconsWrap';
import SupportIconWrap from './styled/SupportIconWrap';
import SupportIconImageWrap from './styled/SupportIconImageWrap';

const SupportIcons: React.FC<WithTranslation> = props => (
  <SupportIconsWrap>
    <SupportIconWrap>
      <SupportIconImageWrap width="57px" height="82px">
        <img src={phone} alt="" />
      </SupportIconImageWrap>

      <span>
        {props.t('business.index.case_study.support.preposition')}{' '}
        <span>
          <strong>20</strong> %
        </span>{' '}
        {props.t('business.index.case_study.support.less_calls')}
      </span>
    </SupportIconWrap>

    <SupportIconWrap>
      <SupportIconImageWrap width="65px" height="65px">
        <img src={watch} alt="" />
      </SupportIconImageWrap>

      <span>
        {props.t('business.index.case_study.support.preposition')}{' '}
        <span>
          <strong>10</strong> %
        </span>{' '}
        {props.t('business.index.case_study.support.faster')}
      </span>
    </SupportIconWrap>
  </SupportIconsWrap>
);

export default withTranslation('pages')(SupportIcons);
